// Compiled at 2026-09-18T12:45:23.821Z
import { unwrapReadonly, assignCommonProperties, coerceDataType, createReadonlyProxy } from "@lg/shared/for-apps";
import * as Ramda from "ramda";
import * as $Modules from "../../Module/$modules.js";
import { Orders, Orders as This, System, Common } from "../../Module/$modules.js";
import type { HasId, IdType, Class, DeepReadonly, NominalType } from "@lg/shared";
import { Sys, ExecutionService } from "@lg/ng-shared";
// Auto-generated by Lowgile
import { Component, OnInit, AfterViewInit, Input, Output, EventEmitter, ChangeDetectionStrategy, inject, input, signal, computed, effect, linkedSignal, viewChild } from "@angular/core";
import { NavigationSkipped } from "@angular/router";
import { AppState, app } from "../../ClientDataStore/$state";
import { AbstractScreen } from "@lg/ng-shared";
import type { ValidationRules } from "@lg/shared";
import { BoInfoSymbol } from "@lg/shared/for-apps";
import { ProxyTargetSymbol } from "@lg/shared/for-apps";
import { Semaphore } from "@lg/shared/for-apps";
import { memoize } from "@lg/shared/for-apps";
import { NgSharedModule } from "@lg/ng-shared";
import { combineLatest, filter } from "rxjs";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { ProcessTaskComponent } from "../../components/process-task.component";
import { proxySignal, ProxySignal } from "../../signals.js";
import { MatTabsModule } from "@angular/material/tabs";
import { CustomerRequestInclude as Orders__CustomerRequestInclude } from "../Orders/CustomerRequestInclude.js";
import { VendorOffersInclude as Orders__VendorOffersInclude } from "../Orders/VendorOffersInclude.js";
import { VendorOffersComparisonInclude as Orders__VendorOffersComparisonInclude } from "../Orders/VendorOffersComparisonInclude.js";

interface Properties {
    request: This.CustomerRequest;
    offerId: This.VendorOffer.Id | undefined;
}

interface State {
    app: AppState;
    screen: Properties;
}

@Component({
    selector: 'Orders-CustomerRequestViewInclude',
    templateUrl: './CustomerRequestViewInclude.html',
    styleUrls: ['./CustomerRequestViewInclude.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        NgSharedModule,
        MatTabsModule,
        Orders__CustomerRequestInclude,
        Orders__VendorOffersInclude,
        Orders__VendorOffersComparisonInclude
    ],
})
export class CustomerRequestViewInclude extends AbstractScreen implements OnInit, AfterViewInit {
    static readonly $canBeMainScreen = true;
    static readonly $canBeDialogScreen = true;
    readonly $qualifiedScreenName = 'Orders.CustomerRequestViewInclude';
    $isDialog = false;
    $Modules = $Modules;
    Orders = Orders;
    System = System;
    Common = Common;
    Sys = Sys;
    This = This;
    app = app;
    $scope = {};
    $pathSegments: string[] = [];
    $processTaskComponent = inject(ProcessTaskComponent, { optional: true });
    output = {

    };
    $validators: Record<number, ValidationRules> = {

    };
    input_request = input(undefined, { alias: 'request' });
    var_request = proxySignal<This.CustomerRequest>(undefined as any);
    input_offerId = input(undefined, { alias: 'offerId' });
    var_offerId = proxySignal<This.VendorOffer.Id | undefined>(undefined as any);
    readonly screen =
        ((component: typeof this) => {
            return {
                get request() { return component.var_request() },
                set request(value: This.CustomerRequest) { component.var_request.set(value) },
                get offerId() { return component.var_offerId() },
                set offerId(value: This.VendorOffer.Id | undefined) { component.var_offerId.set(value) }
            }
        })(this)
        ;

    get $inputs() {
        return {
            request: this.screen.request,
            offerId: this.screen.offerId
        }
    }

    async ngOnInit(): Promise<void> {
        super.ngOnInit()
        if (!this.$processTaskComponent) {
            this.processService.tokenId.set(undefined)
        }


    }

    async ngAfterViewInit(): Promise<void> {
    }

    constructor() {

        super()

        effect(() => {
            if (!this.authService.isInitialized()) return
            const isVariablesInitialized = this.$isVariablesInitialized()
            const { screen, app } = this

            const new_request = this.dialogData?.data?.request ?? this.input_request() ?? (undefined)
            if (new_request !== undefined) this.screen.request = new_request


            const new_offerId = this.dialogData?.data?.offerId ?? this.input_offerId() ?? (undefined)
            if (new_offerId !== undefined) this.screen.offerId = new_offerId

            this.$isVariablesInitialized.set(true)
        })

        effect(() => {
            if (!this.$isVariablesInitialized()) return
            if (!this.$isOnInitCalled) {
                this.$isOnInitCalled = true
                setTimeout(async () => {
                    await this.action_onInit()
                    this.$isFullyInitialized.set(true)
                })
            }
        })



    }

    async action_onInit($event?: any) {
        const { app, screen, output } = this
        {

        }
    }
}
